module.exports = __webpack_public_path__ + "img/VERANO.9a8e1fef.png";